import React, { useEffect, useState } from 'react';
import { motion, useReducedMotion } from 'framer-motion';
import { VE_BANK_ASSETS } from '../lib/brand';
import { Faq } from '../components/landing/Faq';
import { StoreBadges } from '../components/landing/StoreBadges';
import { CapabilityShowcase } from '../components/landing/CapabilityShowcase';
import { StoryStack } from '../components/landing/StoryStack';
import { LivePhone } from '../components/landing/LivePhone';
import { useParallax } from '../components/landing/useParallax';
import { VeeMascot } from '../components/VeeMascot';
const proofItems = ['No preselected financial commitments', 'Progress reflects genuinely completed steps', 'Favourites stay editable and reversible'];
export function Landing({
  onLaunch
}: {
  onLaunch: () => void;
}) {
  const reduced = useReducedMotion();
  const [condensed, setCondensed] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const portrait = useParallax(0.1);
  const ribbon = useParallax(0.05);
  useEffect(() => {
    const onScroll = () => setCondensed(window.scrollY > 64);
    onScroll();
    window.addEventListener('scroll', onScroll, {
      passive: true
    });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);
  const rise = (delay: number) => reduced ? {} : {
    initial: {
      opacity: 0,
      y: 26
    },
    animate: {
      opacity: 1,
      y: 0
    },
    transition: {
      duration: 0.6,
      delay,
      ease: [0.22, 1, 0.36, 1] as [number, number, number, number]
    }
  };
  return <main className="bg-brand-cloud text-brand-navy [overflow-x:clip]" data-id="element-459" data-mp="l2cksp2kvffa">
      <header className={`sticky top-0 z-40 border-b transition-colors duration-300 ${condensed ? 'border-slate-200/80 bg-white/[.94] backdrop-blur-xl' : 'border-transparent bg-brand-cloud/[.85] backdrop-blur-md'}`} data-id="element-460" data-mp="gzq1jcjz32tp">
        <div className="mx-auto flex max-w-7xl items-center justify-between px-5 py-3 lg:px-10" data-id="element-461" data-mp="770pafgllkxb">
          <img src={VE_BANK_ASSETS.wordmark} alt="VE Bank" width={320} height={54} className="h-6 w-auto sm:h-7" data-id="element-462" data-mp="14qllxom3mvqx" />
          <nav aria-label="Sections" className="hidden items-center gap-7 text-xs font-extrabold text-brand-slate md:flex" data-id="element-463" data-mp="1iu13ltq0jthy">
            <a href="#premium" className="flex min-h-[44px] items-center transition-colors hover:text-brand-navy" data-id="element-464" data-mp="1ntdqufksr2l2">Premium Service</a>
            <a href="#control" className="flex min-h-[44px] items-center transition-colors hover:text-brand-navy" data-id="element-465" data-mp="1a17lloj6mg0e">Control</a>
            <a href="#security" className="flex min-h-[44px] items-center transition-colors hover:text-brand-navy" data-id="element-466" data-mp="1e0y8vi9i2e06">Security</a>
            <a href="#faq" className="flex min-h-[44px] items-center transition-colors hover:text-brand-navy" data-id="element-467" data-mp="152cr3pbur30g">FAQ</a>
          </nav>
          <div className="flex items-center gap-3" data-id="element-468" data-mp="r46fu1ht0bve">
            <button onClick={onLaunch} className="hidden min-h-[44px] rounded-xl bg-brand-navy px-4 text-xs font-extrabold text-white transition-transform active:scale-95 sm:block" data-id="element-469" data-mp="v4gm7f9id4as">Explore the app</button>
            <button onClick={() => setMenuOpen(true)} aria-label="Open menu" className="flex h-11 w-11 items-center justify-center rounded-xl bg-white text-brand-navy shadow-sm md:hidden" data-id="element-470" data-mp="2pi7rk2kt120f">
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" data-id="element-471" data-mp="9tj13juo0j5a"><path d="M4 6h16M4 12h16M4 18h16" data-id="element-472" data-mp="nlh3lbtvfgsh" /></svg>
            </button>
          </div>
        </div>
      </header>

      {/* Mobile Side Menu */}
      {menuOpen && <div className="fixed inset-0 z-50 flex justify-end md:hidden" data-id="element-473" data-mp="ise4ko6brf4w">
          <div aria-hidden="true" onClick={() => setMenuOpen(false)} className="absolute inset-0 bg-brand-navy/20 backdrop-blur-sm" data-id="element-474" data-mp="xhk64ismxhfy" />
          <nav aria-label="Mobile navigation" className="relative flex w-[80%] max-w-sm flex-col bg-white px-6 py-8 shadow-2xl" data-id="element-475" data-mp="16jtbku91qkmh">
            <div className="flex items-center justify-between" data-id="element-476" data-mp="11kgsmklapxp6">
              <img src={VE_BANK_ASSETS.wordmark} alt="VE Bank" className="h-6 w-auto" data-id="element-477" data-mp="38b6g3i73qqi0" />
              <button onClick={() => setMenuOpen(false)} aria-label="Close menu" className="flex h-11 w-11 items-center justify-center rounded-xl bg-brand-cloud text-brand-navy" data-id="element-478" data-mp="38czp3456tmt6">✕</button>
            </div>
            <div className="mt-10 flex flex-col gap-6 text-lg font-extrabold text-brand-navy" data-id="element-479" data-mp="35t2ynkkfmb1f">
              <a href="#premium" onClick={() => setMenuOpen(false)} data-id="element-480" data-mp="39u6g2bi4of4r">Premium Service</a>
              <a href="#control" onClick={() => setMenuOpen(false)} data-id="element-481" data-mp="3epc0t6zsnnr9">Control</a>
              <a href="#security" onClick={() => setMenuOpen(false)} data-id="element-482" data-mp="3jpzp3kwn1qhs">Security</a>
              <a href="#faq" onClick={() => setMenuOpen(false)} data-id="element-483" data-mp="2m3smuhnt4a8l">FAQ</a>
            </div>
            <div className="mt-auto pt-8" data-id="element-484" data-mp="2r12kgklcns7i">
              <button onClick={() => {
            setMenuOpen(false);
            onLaunch();
          }} className="min-h-[56px] w-full rounded-2xl bg-brand-navy px-4 text-sm font-extrabold text-white" data-id="element-485" data-mp="2r23v4nygecop">Explore the app</button>
            </div>
          </nav>
        </div>}

      <section ref={portrait.ref} className="relative overflow-hidden px-5 pb-16 pt-12 lg:px-10 lg:pb-24 lg:pt-16" data-id="element-486" data-mp="23crr02hzgut9">
        <div ref={ribbon.ref} aria-hidden="true" className="pointer-events-none absolute inset-0 z-0 overflow-hidden" data-id="element-487" data-mp="28ab2iunaqthi">
          <img src={VE_BANK_ASSETS.flowRibbon} alt="" width={1536} height={1024} className="absolute -left-[18%] top-[38%] w-[135%] max-w-none opacity-45 lg:top-[30%] lg:w-[92%]" style={{
          transform: `translate3d(0, ${ribbon.offset}px, 0)`
        }} data-id="element-488" data-mp="20rblgvnb5e1b" />
        </div>
        <div className="relative z-10 mx-auto grid max-w-7xl items-center gap-10 lg:grid-cols-[.94fr_1.06fr] lg:gap-14" data-id="element-489" data-mp="1hszb56knty45">
          <motion.div {...rise(0)} data-id="element-490" data-mp="1d1pli5z42us9">
            <div className="flex items-center gap-3" data-id="element-491" data-mp="1d0oc05xqugcn">
              <span className="h-px w-10 bg-brand-cobalt" data-id="element-492" data-mp="182mrdgko68z2" />
              <p className="text-[10px] font-extrabold uppercase tracking-[.2em] text-brand-cobalt" data-id="element-493" data-mp="1811xlt66iu29">The clear-money system</p>
            </div>
            <motion.h1 {...rise(0.07)} className="mt-5 max-w-[15ch] text-[40px] font-extrabold leading-[1.05] tracking-[-.05em] sm:text-[56px] sm:leading-[.9] lg:text-[76px] lg:tracking-[-.075em]" data-id="element-494" data-mp="y5i237vj1xe1">
              Banking, rebuilt around <span className="text-brand-cobalt" data-id="element-495" data-mp="jhi1xf34mskr">your next move.</span>
            </motion.h1>
            <motion.p {...rise(0.14)} className="mt-6 max-w-[52ch] text-sm leading-relaxed text-brand-slate sm:text-lg lg:mt-7" data-id="element-496" data-mp="oifg7gl0n2gz">
              VE Bank combines a deeply human account experience with intelligent assistance that helps you understand, prepare, and decide—without ever taking control away.
            </motion.p>
            <motion.div {...rise(0.21)} className="mt-8" data-id="element-497" data-mp="13727mgnx3kok"><StoreBadges onClick={onLaunch} data-id="element-498" data-mp="177m21ch3wa70" /></motion.div>
            <motion.dl {...rise(0.28)} className="mt-8 flex flex-wrap items-baseline gap-x-6 gap-y-2 text-[11px] font-bold text-brand-slate sm:text-xs lg:mt-9 lg:gap-x-7" data-id="element-499" data-mp="1772p6a6bcbzu">
              <Chip value="100%" label="human confirmation" data-id="element-500" data-mp="ye939twd2ed0" />
              <Chip value="₦0" label="hidden fee surprises" data-id="element-501" data-mp="1m5eh63iqqwko" />
              <Chip value="24/7" label="Vee guidance" data-id="element-502" data-mp="1m3tl29gs35kp" />
            </motion.dl>
          </motion.div>

          <motion.div {...rise(0.12)} className="relative mx-auto flex w-full max-w-[560px] justify-center pt-4 lg:pt-0" data-id="element-503" data-mp="1qxxvx3t5zxr2">
            <img src={VE_BANK_ASSETS.portraitMosaic} alt="VE Bank customers in Nigeria" width={1536} height={1024} className="pointer-events-none absolute left-1/2 top-0 z-0 w-[140%] max-w-none -translate-x-1/2 opacity-90 lg:w-[108%]" style={{
            transform: `translate3d(-50%, ${portrait.offset}px, 0)`
          }} data-id="element-504" data-mp="1w91lzjq8b20j" />
            <div aria-hidden="true" className="pointer-events-none absolute inset-x-[5%] inset-y-0 z-[1] bg-[radial-gradient(ellipse_at_center,rgba(244,247,251,.9)_38%,rgba(244,247,251,0)_74%)] lg:inset-x-[12%]" data-id="element-505" data-mp="1da7acjm2ahol" />
            <div className="relative z-10 w-[82%] max-w-[320px] py-6 lg:w-[70%] lg:max-w-[280px]" data-id="element-506" data-mp="1macgkqfira16">
              <LivePhone path="/home" label="VE Bank Home screen showing account balance and cash flow" float={!reduced} data-id="element-507" data-mp="32om3dg444qpw" />
            </div>
          </motion.div>
        </div>
      </section>

      <section id="premium" className="bg-brand-cloud pb-16 pt-10 lg:pb-24 lg:pt-16" data-id="element-508" data-mp="w150akeyboa2">
        <div className="mx-auto mb-16 max-w-7xl px-5 lg:mb-24 lg:px-10" data-id="element-509" data-mp="102gg5y80wv52">
          <motion.div initial={reduced ? undefined : {
          opacity: 0,
          y: 40,
          scale: 0.98
        }} whileInView={reduced ? undefined : {
          opacity: 1,
          y: 0,
          scale: 1
        }} viewport={{
          once: true,
          amount: 0.2
        }} transition={{
          duration: 0.6,
          ease: [0.22, 1, 0.36, 1]
        }} className="relative overflow-hidden rounded-[34px] bg-white shadow-[0_30px_80px_-42px_rgba(6,24,39,.55)]" data-id="element-510" data-mp="102qafy03pogk">
            <div className="grid lg:grid-cols-[1.1fr_.9fr]" data-id="element-511" data-mp="1nsargbcp2bn7">
              <div className="p-6 sm:p-12 lg:p-16" data-id="element-512" data-mp="1nsu9ds2ch018">
                <p className="text-[10px] font-extrabold uppercase tracking-[.2em] text-brand-cobalt" data-id="element-513" data-mp="1srnofoxa4z3i">Always available</p>
                <h2 className="mt-4 max-w-[16ch] text-[28px] font-extrabold leading-[1.05] tracking-[-.05em] text-brand-navy sm:mt-5 sm:text-4xl lg:text-[46px] lg:leading-[1.02]" data-id="element-514" data-mp="3pkpj4251iugt">
                  A relationship manager in your pocket.
                </h2>
                <p className="mt-4 max-w-[42ch] text-sm leading-relaxed text-brand-slate sm:mt-5 sm:text-base" data-id="element-515" data-mp="3i89f3lllknk9">
                  Vee is trained to understand your financial life and is always ready to help. And when a situation needs a human touch, Vee seamlessly connects you to a real advisor who already has the context.
                </p>
                <button className="mt-6 min-h-[52px] rounded-2xl bg-brand-navy px-6 text-sm font-extrabold text-white sm:mt-8 transition-transform active:scale-95" data-id="element-516" data-mp="9r4zhk8rmsif">
                  Meet your advisor
                </button>
              </div>
              <div className="relative min-h-[320px] bg-brand-cloud lg:min-h-full" data-id="element-517" data-mp="3ry2teud4jgs7">
                <img src="https://cdn.magicpatterns.com/patterns/generated-images/f01c684e-9842-4a80-b61f-b3d76d58140b.jpg" alt="A professional VE Bank advisor smiling in a modern office" className="absolute inset-0 h-full w-full object-cover" data-id="element-518" data-mp="3s05gb5izctsp" />
              </div>
            </div>
          </motion.div>
        </div>
        <StoryStack data-id="element-519" data-mp="en6i0byk1u08" />
      </section>

      <section id="control" className="border-y border-slate-200 bg-white py-16 lg:px-10 lg:py-24" data-id="element-520" data-mp="scgqvj3yzzyk">
        <div className="mx-auto grid max-w-6xl gap-10 px-5 lg:grid-cols-2 lg:items-center lg:gap-20 lg:px-0" data-id="element-521" data-mp="nma31lha8jhd">
          <motion.div initial={reduced ? undefined : {
          opacity: 0,
          x: -30
        }} whileInView={reduced ? undefined : {
          opacity: 1,
          x: 0
        }} viewport={{
          once: true,
          amount: 0.3
        }} transition={{
          duration: 0.6,
          ease: [0.22, 1, 0.36, 1]
        }} className="relative order-2 lg:order-1" data-id="element-522" data-mp="12aelqpgc4v05">
            <div className="rounded-[28px] bg-[#061827] p-6 text-white sm:rounded-[30px] sm:p-9" data-id="element-523" data-mp="16dazo2uxk2xr">
              <p className="text-[10px] font-extrabold uppercase tracking-[.16em] text-brand-electric" data-id="element-524" data-mp="3d37s2wr53uoa">Payment review</p>
              <p className="mt-4 text-[36px] font-extrabold leading-none tabular-nums sm:text-[40px]" data-id="element-525" data-mp="38690akuy7zt9">₦25,000.00</p>
              <dl className="mt-6 space-y-3.5 border-t border-white/10 pt-5 text-xs sm:mt-7" data-id="element-526" data-mp="1sknhrd8v5rfb">
                <div className="flex justify-between" data-id="element-527" data-mp="1eticnvmq86xl"><dt className="text-slate-400" data-id="element-528" data-mp="1esh35vlczshz">From</dt><dd className="font-bold" data-id="element-529" data-mp="1erfo7g182luz">VE Bank Account</dd></div>
                <div className="flex justify-between" data-id="element-530" data-mp="1itsss148gdq6"><dt className="text-slate-400" data-id="element-531" data-mp="1isr58x615yrk">Fee</dt><dd className="font-bold" data-id="element-532" data-mp="14v2wuot5gk3e">₦0.00</dd></div>
                <div className="flex justify-between" data-id="element-533" data-mp="14xp40nc4oxl3"><dt className="text-slate-400" data-id="element-534" data-mp="19uyso0rp157v">Total debit</dt><dd className="font-bold text-brand-electric" data-id="element-535" data-mp="19vqo9blaj2y5">₦25,000.00</dd></div>
              </dl>
            </div>
            <img src={VE_BANK_ASSETS.biometricReview} alt="Review panels beside a biometric confirmation control" loading="lazy" width={1440} height={1080} className="pointer-events-none absolute -bottom-12 -right-6 hidden w-[42%] max-w-[240px] lg:block" data-id="element-536" data-mp="vx0qruuk7199" />
          </motion.div>
          <motion.div initial={reduced ? undefined : {
          opacity: 0,
          x: 30
        }} whileInView={reduced ? undefined : {
          opacity: 1,
          x: 0
        }} viewport={{
          once: true,
          amount: 0.3
        }} transition={{
          duration: 0.6,
          ease: [0.22, 1, 0.36, 1]
        }} className="order-1 lg:order-2" data-id="element-537" data-mp="2u9hg4tleferi">
            <p className="text-[10px] font-extrabold uppercase tracking-[.2em] text-brand-cobalt" data-id="element-538" data-mp="3p7g1ghk5sxag">Control without friction</p>
            <h2 className="mt-4 max-w-[18ch] text-[28px] font-extrabold leading-[1.05] tracking-[-.05em] sm:text-4xl lg:text-[46px] lg:leading-[.98]" data-id="element-539" data-mp="pskpqn83bxd1">The clarity to act. The freedom to change your mind.</h2>
            <p className="mt-4 max-w-[46ch] text-sm leading-relaxed text-brand-slate sm:mt-5 sm:text-base" data-id="element-540" data-mp="gyz9ezga281i">Personalisation is always editable. Safe defaults never commit you to a payment. When there is a real consequence, we explain it plainly at the point it matters.</p>
            <ul className="mt-6 space-y-3.5 border-t border-slate-200 pt-6 sm:mt-8 sm:pt-7" data-id="element-541" data-mp="14pv88gj5i3i9">
              {proofItems.map(item => <li key={item} className="flex items-baseline gap-3 text-sm font-bold text-brand-slate" data-id="element-542" data-mp="1c21gstys5b1q">
                  <span aria-hidden="true" className="h-1.5 w-1.5 shrink-0 rounded-full bg-brand-cobalt" data-id="element-543" data-mp="1h0crt80t9rlj" />{item}
                </li>)}
            </ul>
          </motion.div>
        </div>
      </section>

      <section id="security" className="mx-auto max-w-6xl px-5 py-16 lg:px-10 lg:py-24" data-id="element-544" data-mp="1q1u2ubzd333d">
        <motion.div initial={reduced ? undefined : {
        opacity: 0,
        y: 40,
        scale: 0.98
      }} whileInView={reduced ? undefined : {
        opacity: 1,
        y: 0,
        scale: 1
      }} viewport={{
        once: true,
        amount: 0.2
      }} transition={{
        duration: 0.6,
        ease: [0.22, 1, 0.36, 1]
      }} className="relative overflow-hidden rounded-[32px] bg-[linear-gradient(145deg,#071f37,#246BFE_70%,#6747E8)] px-6 py-12 text-center text-white sm:rounded-[40px] lg:px-14 lg:py-20" data-id="element-545" data-mp="1uzc4rieyoi1v">
          <img src={VE_BANK_ASSETS.flowRibbon} alt="" aria-hidden="true" loading="lazy" width={1536} height={1024} className="pointer-events-none absolute -bottom-10 -left-16 w-[70%] max-w-none opacity-25" data-id="element-546" data-mp="2ippz5fl0qszm" />
          <div className="relative mx-auto max-w-2xl" data-id="element-547" data-mp="210m6na2dhnib">
            <VeeMascot size={96} state="speaking" decorative className="sm:h-[112px] sm:w-[112px]" data-id="element-548" data-mp="2esslmstshog6" />
            <p className="mt-6 text-[10px] font-extrabold uppercase tracking-[.2em] text-blue-100 sm:mt-8" data-id="element-549" data-mp="29so7vak9n7tn">Designed for confidence</p>
            <h2 className="mx-auto mt-4 max-w-[18ch] text-[28px] font-extrabold leading-[1.05] tracking-[-.05em] sm:text-4xl lg:text-[46px] lg:leading-[.98]" data-id="element-550" data-mp="1m43t3i6surg1">Vee adds intelligence. You retain authority.</h2>
            <p className="mx-auto mt-4 max-w-[52ch] text-sm leading-relaxed text-blue-100 sm:mt-5 sm:text-base" data-id="element-551" data-mp="1w32ssb9l7cqw">The companion can explain and prepare, but it cannot use your credentials, approve a payment, or move your money. That boundary is visible across the experience.</p>
            <button onClick={onLaunch} className="mt-8 min-h-[52px] rounded-2xl bg-white px-6 text-sm font-extrabold text-brand-navy sm:mt-9 transition-transform active:scale-95" data-id="element-552" data-mp="32h23jjnvts21">Explore customer-controlled flows</button>
          </div>
        </motion.div>
      </section>

      <section id="faq" className="bg-[#061827] px-5 py-16 text-white lg:px-10 lg:py-24" data-id="element-553" data-mp="f9xn9wvvxgpb">
        <div className="mx-auto max-w-3xl" data-id="element-554" data-mp="k87ig7hm0hax">
          <p className="text-center text-[10px] font-extrabold uppercase tracking-[.2em] text-brand-electric" data-id="element-555" data-mp="k90tvlrijuze">Clear answers</p>
          <h2 className="mt-4 text-center text-[28px] font-extrabold leading-[1.05] tracking-[-.05em] sm:text-4xl lg:text-[44px]" data-id="element-556" data-mp="18066ls25q75h">Designed to earn trust in the details.</h2>
          <div className="mt-8 sm:mt-10" data-id="element-557" data-mp="y7qqz1ec1unr"><Faq data-id="element-558" data-mp="y6fmezd2civl" /></div>
        </div>
      </section>

      <footer className="bg-brand-cloud px-5 py-12 lg:px-10" data-id="element-559" data-mp="136bi8bblx402">
        <div className="mx-auto flex max-w-7xl flex-col gap-6 sm:flex-row sm:items-end sm:justify-between" data-id="element-560" data-mp="1qx7fvp2qutf8">
          <div data-id="element-561" data-mp="1vo5y4u7am1l4">
            <img src={VE_BANK_ASSETS.wordmark} alt="VE Bank" loading="lazy" width={320} height={54} className="h-8 w-auto" data-id="element-562" data-mp="1vnwahd9q06il" />
            <p className="mt-3 max-w-sm text-xs leading-relaxed text-brand-slate" data-id="element-563" data-mp="25j4i8bnr30t8">A digital banking prototype built for clear decisions, transparent payments, and customer control.</p>
          </div>
          <p className="text-xs font-bold text-brand-slate" data-id="element-564" data-mp="1vjvrrss3g4bm">© 2026 VE Bank</p>
        </div>
      </footer>
    </main>;
}
function Chip({
  value,
  label
}: {
  value: string;
  label: string;
}) {
  return <div className="flex items-baseline gap-2" data-id="element-565" data-mp="1mmbmm8r41nvq">
      <dt className="text-lg font-extrabold tabular-nums text-brand-navy" data-id="element-566" data-mp="1hubsiwxq1p72">{value}</dt>
      <dd data-id="element-567" data-mp="1cuyx3nssb9sv">{label}</dd>
    </div>;
}